/*# sourceMappingURL=laboratory-result-section.component-GHDIEMKC.css.map */
